import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { KitCard, KitCardBody, KitButton } from 'components/common/cms-kit';
import { PRODUCTS } from 'services/constants';

const CardLabel = ({ label }) => {
  return (
    <Typography
      variant='subtitle2'
      component='span'
      sx={{
        color: 'text.secondary',
        marginRight: '5px',
        display: 'inline-block'
      }}>
      {label}
    </Typography>
  );
};

const CardValue = ({ value }) => {
  return (
    <Typography
      variant='subtitle2'
      component='span'
      title={value}
      sx={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        overflow: 'hidden',
        maxWidth: '300px',
        verticalAlign: 'middle'
      }}>
      {value}
    </Typography>
  );
};

const CouponCodeCard = (props) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <KitCard style={{ width: '80%', color: `${theme.palette.primary.main}` }}>
        <KitCardBody>
          <Typography variant='h6' sx={{ textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {props.couponCode.code}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: '10px', marginTop: '10px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
              <div>
                <CardLabel label='Product' />
                <CardValue value={PRODUCTS.find((p) => p.id === props.couponCode.product)?.name ?? ''} />
              </div>
              <div>
                <CardLabel label='Exp Date' />
                <CardValue value={props.couponCode.exp_date} />
              </div>
              <div>
                <CardLabel label='Type' />
                <CardValue value={props.couponCode.type} />
              </div>
              <div>
                <CardLabel label='Value' />
                <CardValue value={props.couponCode.value} />
              </div>
              <div>
                <CardLabel label='Active' />
                <CardValue value={<Checkbox checked={props.couponCode.is_active} disabled />} />
              </div>
            </Box>
          </Box>
          <KitButton round style={{ float: 'right' }} color='info' size='sm' onClick={() => props.editFunc()} title='Edit'>
            <EditIcon /> Edit
          </KitButton>
        </KitCardBody>
      </KitCard>
    </Box>
  );
};

CouponCodeCard.propTypes = {
  couponCode: PropTypes.object.isRequired,
  editFunc: PropTypes.func.isRequired,
};

export default CouponCodeCard;
